import React, { useContext, useState } from 'react';
import { DndProvider, DropTargetMonitor, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useToast } from '../../../controller/ToastController';
import { AuthContext } from '../../../navigation/AuthProvider';

const example = [
  {
    coupon_id: 1,
    coupon_name: '겨울맞이 눈꽃쿠폰',
    discount_percent: 30,
    discount_price: 0,
    min_price: 2500,
    max_discounted_price: 1000,
    expired_time: '2024/02/10',
    coupon_count: 50,
    downloaded_user_count: 40,
  },
  {
    coupon_id: 2,
    coupon_name: '새학기 봄맞이? 쿠폰',
    discount_percent: 50,
    discount_price: 0,
    min_price: 0,
    max_discounted_price: 10000,
    expired_time: '2024/02/12',
    coupon_count: 1000,
    downloaded_user_count: 20,
  },
  {
    coupon_id: 3,
    coupon_name: '혹서기 여름맞이 쿠폰',
    discount_percent: 0,
    discount_price: 5000,
    min_price: 5000,
    max_discounted_price: 5000,
    expired_time: '2024/02/02',
    coupon_count: 50,
    downloaded_user_count: 40,
  },
  {
    coupon_id: 4,
    coupon_name: '새학기 가을맞이 쿠폰',
    discount_percent: 0,
    discount_price: 10000,
    min_price: 100000,
    max_discounted_price: 10000,
    expired_time: '2024/02/01',
    coupon_count: 50,
    downloaded_user_count: 40,
  },
];

const CouponIndex = () => {
  const navigate = useNavigate();
  const showToast = useToast();
  const [couponList, setCouponList] = useState<any>(example);
  const oAuthContext = useContext(AuthContext);
  const [isOpen, setIsOpen] = useState<boolean[]>(new Array(example.length).fill(false));

  const navigateCouponInfo = async (coupon_info?: any) => {
    if (coupon_info) {
      // const productInfo = await getSelectedProduct(product_id!);
      navigate(`/product/coupon/edit`, { state: { couponInfo: coupon_info } });
    } else navigate(`/product/coupon/edit`);
  };

  // API 호출
  // const getCategoryData = async () => {
  //   try {
  //
  //     const oRes = await ProductController.getAllCateProduct(currentStore.value); // test

  //     if (oRes && oRes.data) {
  //       const oResponse = oRes.data;
  //       console.log('getCategoryData', oResponse);
  //       if (oResponse.data) {
  //         setCategoryList([...oResponse.data]);
  //         setIsOpen(new Array(oResponse.data.length).fill(false));
  //       }
  //     }
  //   } catch (err) {
  //     console.log('err---->', err);
  //   }
  // };

  // const changeIndexCategoryData = async () => {
  //   try {
  //     const oRes = await ProductController.editCateProductIdOrder(currentStore.value, categoryList); // test
  //     if (oRes && oRes.data) {
  //       const oResponse = oRes.data;
  //       console.log('delCategory', oResponse);
  //       if (oResponse.data && oResponse.ok) {
  //         showToast('상품분류의 순서를 변경했어요');
  //       }
  //     }
  //   } catch (err) {
  //     console.log('err---->', err);
  //   }
  // };

  // useEffect(() => {
  //   getCategoryData();
  // }, []);

  const moveItem = (fromIndex: number, toIndex: number) => {
    if (toIndex < 1) toIndex = 0;
    else if (toIndex > couponList.length - 1) toIndex = couponList.length;
    const newItems = [...couponList];
    const [movedItem] = newItems.splice(fromIndex, 1);
    newItems.splice(toIndex, 0, movedItem);
    setCouponList(newItems);
    setIsOpen(new Array(couponList.length).fill(false));
  };

  interface DraggableItemProps {
    item: any;
    index: number;
    moveItem: (fromIndex: number, toIndex: number) => void;
  }

  const RenderCoupon = ({ item, index, moveItem }: DraggableItemProps) => {
    const [selectedIndex, setSelectedIndex] = useState<number>(index + 1);

    const changeIsOpen = () => {
      const dataTemp = isOpen;
      dataTemp[index] = !dataTemp[index];
      setIsOpen([...dataTemp]);
    };

    const [, drag] = useDrag({
      type: 'ITEM',
      item: { item, index },
    });

    const [, drop] = useDrop({
      accept: 'ITEM',
      hover: (item: { index: number }, monitor: DropTargetMonitor) => {
        if (item.index !== index) {
          moveItem(item.index, index);
          item.index = index;
        }
      },
    });

    return (
      <div key={index}>
        <div className={`listItem ${isOpen[index] && 'open'}`}>
          <div className="row gap">
            <input
              ref={(node) => drag(drop(node))}
              value={selectedIndex}
              autoFocus={false}
              onChange={(e) => {
                setSelectedIndex(Number(e.target.value));
              }}
              onBlur={() => {
                moveItem(index, selectedIndex - 1);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  moveItem(index, selectedIndex - 1);
                }
              }}
            />
            <h3>{item.coupon_name}</h3>
          </div>
          <div className="row gap">
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_edit.svg`}
              alt="ic"
              onClick={() => navigateCouponInfo(item)}
            />
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_arrow_${
                isOpen[index] ? 'up' : 'down'
              }_grey.svg`}
              onClick={changeIsOpen}
              width={30}
              height={30}
              alt="ic"
            />
          </div>
        </div>
        {isOpen[index] && (
          <div className="menuList">
            <div className="menuSideWrap">
              <div className="row between">
                <h4>할인률</h4>
                <h4>{item.discount_percent}%</h4>
              </div>
              <div className="row between">
                <h4>최소주문금액</h4>
                <h4>{item.min_price.toLocaleString()}원</h4>
              </div>
              <div className="row between">
                <h4>쿠폰발행수</h4>
                <h4>{item.coupon_count.toLocaleString()}개</h4>
              </div>
            </div>
            <div className="menuSideWrap noneBorder">
              <div className="row between">
                <h4>최대할인금액</h4>
                <h4>{item.max_discounted_price}원</h4>
              </div>
              <div className="row between">
                <h4>다운받은 고객수</h4>
                <h4>{item.downloaded_user_count.toLocaleString()}명</h4>
              </div>
              <div className="row between">
                <h4>유효기간</h4>
                <h4>~ {item.expired_time}</h4>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <Style>
      <div className="contentContainer">
        <button className="addButton" onClick={() => navigateCouponInfo()}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="ic" />
          <h4>새 쿠폰 추가하기</h4>
        </button>

        <div className="warningSign">
          <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
          <div>
            <p>숫자를 입력하거나 숫자 버튼을 드래그 해서 순서를 변경해주세요.</p>
          </div>
        </div>

        <DndProvider backend={HTML5Backend}>
          {couponList.length > 0 ? (
            <div className="categoryList">
              {couponList.map((item: any, index: number) => {
                return <RenderCoupon key={index} item={item} index={index} moveItem={moveItem} />;
              })}
            </div>
          ) : (
            <div className="noneWrap">
              <h3>상품분류를 등록해주세요</h3>
            </div>
          )}
        </DndProvider>
        <button className={`submitButton`} onClick={() => {}}>
          저장
        </button>
      </div>
    </Style>
  );
};

export default CouponIndex;

const Style = styled.div`
  @keyframes expandDown {
    0% {
      height: 0;
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  input {
    width: 100%;
    padding: 10px 12px 10px 30px;
    border: 1px solid #cecece;
    border-radius: 5px;
  }
  input::placeholder {
    color: #cecece;
  }

  .addButton {
    width: 100%;
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    padding: 8px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5%;
    margin-bottom: 10px;

    h4 {
      font-weight: 600;
      color: #4dd2ae;
      white-space: nowrap;
      padding: 0;
    }
  }

  .categoryList {
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    gap: 30px;

    .listItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 16px 10px 22px;
      background: #ecf5f3;
      border: 1px solid #ecf5f3;
      border-radius: 5px;

      input {
        width: 30px;
        height: 30px;
        padding: 4px;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        text-align: center;
        color: #40977f;
        background: #ecf5f3;
        border: 1px solid #4dd2ae;
        border-radius: 4px;
      }

      .row {
        gap: 6px;
      }
      .row.gap {
        gap: 14px;
      }
      h3 {
        color: #555555;
        font-weight: 600;
      }

      .loadButton {
        display: flex;
        align-items: center;
        border: 1px solid #4dd2ae;
        border-radius: 5px;
        padding: 4px 9px;
        gap: 4px;

        h5 {
          color: #40977f;
          font-weight: 600;
        }
      }
    }
    .listItem.open {
      border-radius: 5px 5px 0 0;
    }

    .menuList {
      display: flex;
      border: 1px solid #e5e5e5;
      border-top: none;
      border-radius: 0 0 5px 5px;
      .menuSideWrap {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding: 20px;
        border-right: 1px solid #e5e5e5;

        h4 {
          font-size: 16px;
          line-height: 22px;
          font-weight: 500;
          color: #555555;
        }
      }
      .menuSideWrap.noneBorder {
        border-right: none;
      }
    }
  }
`;
